import { LocaleID, PlatformID, SubjectID } from '../clients/api';
import { getRecordEntries } from '../utils/getRecordEntries';

export enum Host {
    AB = `autoblog|\\bab\\b`,
    BB = `babybytes|\\bbb\\b`,
    BI = `bicycling|\\bbi\\b`,
    BR = `bright|\\bbr\\b`,
    // Note: WH must come before MH
    WH = `womenshealth|\\bwh\\b`,
    MH = `menshealth|\\bmh\\b`,
    RW = `runners|\\brw\\b`,
    SC = `scientias|\\bsc\\b`,
    VI = `\\bvi\\b`,
    VN = `voetbalnieuws|\\bvn\\b`,
    // Note: VP_BE must come before VP
    VP_BE = `voetbalprimeur\\.be|voetbalprimeurbe|\\bvp-?be\\b`,
    VP = `voetbalprimeur|\\bvp\\b`,
}

export const HostRegexByHost: Record<Host, RegExp> = Object.fromEntries(
    Object.values(Host).map((host): [Host, RegExp] => [host, new RegExp(host, 'i')]),
) as Record<Host, RegExp>;

export const DEFAULT_HOST_REGEX = HostRegexByHost[Host.VN];

export const getPlatformIDByHostname = (hostname: string): PlatformID | undefined => {
    const host = getHostByHostname(hostname);
    return host ? PlatformByHost[host] : undefined;
};

export const getHostByHostname = (hostname: string): Host | undefined => {
    for (const [host, regex] of getRecordEntries(HostRegexByHost)) {
        if (regex.test(hostname)) return host;
    }
    return undefined;
};

export const PlatformByHost: Record<Host, PlatformID> = {
    [Host.AB]: PlatformID.AB,
    [Host.BB]: PlatformID.BB,
    [Host.BI]: PlatformID.BI,
    [Host.BR]: PlatformID.BR,
    [Host.MH]: PlatformID.MH,
    [Host.RW]: PlatformID.RW,
    [Host.SC]: PlatformID.SC,
    [Host.VI]: PlatformID.VI,
    [Host.VN]: PlatformID.VN,
    [Host.VP]: PlatformID.VP,
    [Host.VP_BE]: PlatformID.VP,
    [Host.WH]: PlatformID.WH,
};

export const SubjectByPlatform: Record<PlatformID, SubjectID> = {
    [PlatformID.AB]: SubjectID.AUTOMOTIVE,
    [PlatformID.BB]: SubjectID.LIFESTYLE,
    [PlatformID.BI]: SubjectID.LIFESTYLE,
    [PlatformID.BR]: SubjectID.TECH,
    [PlatformID.MH]: SubjectID.LIFESTYLE,
    [PlatformID.RW]: SubjectID.LIFESTYLE,
    [PlatformID.SC]: SubjectID.SCIENCE,
    [PlatformID.VI]: SubjectID.FOOTBALL,
    [PlatformID.VN]: SubjectID.FOOTBALL,
    [PlatformID.VP]: SubjectID.FOOTBALL,
    [PlatformID.WH]: SubjectID.LIFESTYLE,
};

export const LocaleByHost: Record<Host, LocaleID> = {
    [Host.AB]: LocaleID.NL_NL,
    [Host.BB]: LocaleID.NL_NL,
    [Host.BI]: LocaleID.NL_NL,
    [Host.BR]: LocaleID.NL_NL,
    [Host.MH]: LocaleID.NL_NL,
    [Host.RW]: LocaleID.NL_NL,
    [Host.SC]: LocaleID.NL_NL,
    [Host.VI]: LocaleID.NL_NL,
    [Host.VN]: LocaleID.NL_NL,
    [Host.VP]: LocaleID.NL_NL,
    [Host.VP_BE]: LocaleID.NL_BE,
    [Host.WH]: LocaleID.NL_NL,
};
